export default __webpack_public_path__ + "static/media/icon_Copy_.5ef6e968.svg";